import React, { useState, useEffect } from "react"
import Select from "react-select"
import api from "../../../base/services/ResApi"

const GroupsMultiSelect = (props) => {
  const [data, setData] = useState([])
  let apprvConfig = {
    headers: {
      Action: "V_ALL_APPR_GRP",
      "Is-Pagination": "false",
      "Sort-Column": "grp_id",
      "Sort-Order": "asc",
      Value: props.orgCode,
      Filter: "F_ORG_CODE",
    },
  }
  useEffect(() => {
    const fetchData = () => {
      api
        .get("/groups", apprvConfig)
        .then((res) => {
          setData(
            res.data?.dataList.map((d) => ({
              value: d.groupId,
              label: d.groupName,
            }))
          )
        })
        .catch((error) => {
          console.log(error)
        })
    }
    fetchData()
  }, [props.orgCode])

  return (
    <div>
      <Select
        name={props.name}
        onChange={props.onChange}
        options={data}
        isMulti
        placeholder="Select Multi Groups"
        isDisabled={props.isDisabled}
        closeMenuOnSelect={false}
      />
    </div>
  )
}

export default GroupsMultiSelect
